export interface BidLimits {
  min: number;
  max: number;
}

/**
 * An unset bid falls back to the ad group default, so only a set bid is range-checked
 * here — mirroring assertSponsoredDisplayCreationWithinCapabilities on the server.
 */
export function targetBidWithinLimits(bid: number | null, limits: BidLimits): boolean {
  if (bid === null) return true;
  return Number.isFinite(bid) && bid >= limits.min && bid <= limits.max;
}

/** The custom bid is always set, so unlike a target bid an empty value is invalid. */
export function customBidWithinLimits(value: string, limits: BidLimits): boolean {
  const parsed = Number(value);
  return value.trim() !== "" && Number.isFinite(parsed) && targetBidWithinLimits(parsed, limits);
}

export function currencyLabel(currencyCode: string): string {
  return currencyCode === "USD" ? "$" : currencyCode;
}

export function formatMoney(value: number, currencyCode: string): string {
  const label = currencyLabel(currencyCode);
  return label === "$" ? `${label}${value.toFixed(2)}` : `${label} ${value.toFixed(2)}`;
}
